import { useState } from "react";
import dispatchService from "services/dispatch.service";

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from "@mui/material/Grid";
import TextField from '@mui/material/TextField';
import MDButton from 'components/MDButton';

export default function RejectDispatchDialog({
    open,
    handleClose,
    dispatchId,
}) {
    const [dispatch, setDispatch] = useState({});
    const [selOrg, setSelOrg] = useState(null);
    const [errors, setErrors] = useState({});

    // Handles individual field updates to the new order's state
    const changeHandler = (e) => {
        const { name, value } = e.target;
        setDispatch({
            ...dispatch,
            [name]: value
        });
    }

    // Handles batch updates to the new order's state
    const batchChangeHandler = (updates) => {
        setDispatch({
            ...dispatch,
            ...updates
        })
    }

    const handleCancel = () => {
        setDispatch({});
        setSelOrg(null);
        setErrors({});
        handleClose();
    }

    // Handles the submission of the create order form
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            
            setErrors({});
            if (!dispatch.rejection_reason) {
                setErrors({ rejection_reason: "Rejection reason is required." });
                return;
            }
            const payload = {
                data: {
                    attributes: {
                        status: "Rejected",
                        rejectionReason: dispatch.rejection_reason
                    }
                }
            }

            await dispatchService.updateDispatchStatus(dispatchId, payload);
            setDispatch({});
            setSelOrg(null);
            handleClose({reload: true});

        } catch (error) {
            console.error("Error creating order: ", error);
        }
    }

    return (
        <Dialog open={open} onClose={handleCancel}>

            {/* Dialog Title and Context */}
            <DialogTitle> Reject Dispatch Request</DialogTitle>
            <DialogContent>

                <DialogContentText>
                    Please provide a reason for rejecting this dispatch request.
                </DialogContentText>

                {/* Form for Creating the Order */}
                <form onSubmit={handleSubmit} id="subscription-form">
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Rejection Reason"
                                name="rejection_reason"
                                value={dispatch.rejection_reason || ""}
                                onChange={changeHandler}
                            />
                        </Grid>
                    </Grid>


                </form>

            </DialogContent>

            {/* Dialog action buttons */}
            <DialogActions>
                <MDButton
                    color="info"
                    variant="gradient"
                    size="small"
                    onClick={handleCancel}>
                    Cancel
                </MDButton>
                <MDButton
                    color="error"
                    variant="gradient"
                    size="small"
                    type="submit"
                    form="subscription-form">
                    Reject
                </MDButton>
            </DialogActions>

        </Dialog >
    );
}
